import { notify } from "../../../../utils/notify";
import { searchV3 } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/contrato`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getContractCancelledInstallments(contractId) {
  if (!contractId) {
    notify("É necessário informar o ID do contrato.");
    return;
  }
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/${contractId}/installment/cancelled`);

  return searchV3(decodeURIComponent(url), "GET", headers);
}

export async function reactivateContract(contractId, body) {
  if (!contractId) return notify("É necessário informar o ID do contrato.");

  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/${contractId}/reactivate`);

  return searchV3(decodeURIComponent(url), "POST", headers, body);
}
